import { Track } from "livekit-client";

export const DEFAULT_AUDIO_CAPTURE_OPTIONS = Object.freeze({
  echoCancellation: true,
  noiseSuppression: true,
  autoGainControl: true,
});

/**
 * Enable or disable the local microphone and, when enabling it, verify that
 * LiveKit has a usable browser MediaStreamTrack to publish. Browser permission
 * alone does not guarantee that a live track was created.
 */
export async function setVerifiedMicrophoneEnabled(localParticipant, enabled) {
  if (!localParticipant) {
    throw new Error("The classroom media connection is not ready yet.");
  }

  const publication = await localParticipant.setMicrophoneEnabled(
    enabled,
    enabled ? DEFAULT_AUDIO_CAPTURE_OPTIONS : undefined
  );

  if (!enabled) {
    return { publication, mediaTrack: publication?.track?.mediaStreamTrack };
  }

  const activePublication =
    publication || localParticipant.getTrackPublication(Track.Source.Microphone);

  if (!activePublication) {
    throw new Error("LiveKit did not publish a microphone track.");
  }

  if (activePublication.isMuted) {
    await activePublication.unmute();
  }

  const mediaTrack = activePublication.track?.mediaStreamTrack;
  if (!mediaTrack) {
    throw new Error("The browser did not provide a microphone media track.");
  }
  if (mediaTrack.readyState !== "live") {
    throw new Error("The selected microphone is no longer available.");
  }

  // A preview stream or browser/device transition can leave the underlying
  // MediaStreamTrack disabled even though the LiveKit publication is unmuted.
  mediaTrack.enabled = true;

  return { publication: activePublication, mediaTrack };
}

